module.exports = __webpack_public_path__ + "static/media/support-icon.e8b33fc0.svg";